export const routes = {
  dashboard: '/',
  tasks: '/tasks',
  budget: '/budget',
  calendar: '/calendar',
  family: '/family',
  login: '/login',
} as const
